import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../../../core/_base/crud';
import { AffiliationRelation } from '../models';
import { AffiliationRelationActions, AffiliationRelationActionTypes } from '../actions';

export interface AffiliationRelationState extends EntityState<AffiliationRelation> {
  totalCount: number;
  query: QueryParamsModel;
  pageLoading: boolean;
  actionLoading: boolean;
  showInitWaitingMessage: boolean;
  error: any;
}

export const adapter: EntityAdapter<AffiliationRelation> = createEntityAdapter<AffiliationRelation>(
  {
    selectId: (affiliationRelation) => affiliationRelation.id,
  },
);

export const initialAffiliationRelationState: AffiliationRelationState = adapter.getInitialState({
  totalCount: 0,
  query: new QueryParamsModel({}),
  pageLoading: false,
  actionLoading: false,
  showInitWaitingMessage: true,
  error: null,
});

export function affiliationRelationReducer(
  state = initialAffiliationRelationState,
  action: AffiliationRelationActions,
): AffiliationRelationState {
  switch (action.type) {
    case AffiliationRelationActionTypes.ToggleAffiliationRelationPageLoading:
      return { ...state, pageLoading: action.payload.pageLoading };

    case AffiliationRelationActionTypes.ToggleAffiliationRelationActionLoading:
      return { ...state, actionLoading: action.payload.actionLoading };

    case AffiliationRelationActionTypes.LoadAffiliationRelationPage:
      return adapter.addMany(action.payload.affiliationRelations, {
        ...initialAffiliationRelationState,
        totalCount: action.payload.totalCount,
        query: action.payload.query,
        showInitWaitingMessage: false,
      });

    case AffiliationRelationActionTypes.CancelAffiliationRelationPage:
      return { ...state, query: new QueryParamsModel({ searchTerm: '' }) };

    case AffiliationRelationActionTypes.CreateAffiliationRelation:
      return adapter.addOne(action.payload.affiliationRelation, state);

    case AffiliationRelationActionTypes.UpdateAffiliationRelation:
      return adapter.updateOne(action.payload.affiliationRelation, state);

    case AffiliationRelationActionTypes.DeleteAffiliationRelation:
      return adapter.removeOne(action.payload.id, state);

    case AffiliationRelationActionTypes.ThrowAffiliationRelationError:
      return {
        ...state,
        pageLoading: false,
        actionLoading: false,
        error: action.payload.error,
      };

    case AffiliationRelationActionTypes.ClearAffiliationRelationError:
      return { ...state, error: null };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
